import Cookies from 'js-cookie';

import VisitorService from './visitor.service';

const visitorService = new VisitorService(Cookies);

export { visitorService, type VisitorService };
